import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import {
  Box, Grid, FormControl, InputLabel, OutlinedInput, TextField,
  Button, CircularProgress, Divider, Typography,
} from "@mui/material";
import { StoreRole, GetApiLinks } from "api/role.js";
import PermissionEditor from "./PermissionEditor";
import PagePermissionEditor from "./PagePermissionEditor";

function NewRole({ onCreated } = {}) {
  const [role, setRole] = useState("");
  const [description, setDescription] = useState("");
  const [permission, setPermission] = useState([]);
  const [pages, setPages] = useState([]);
  const [remark, setRemark] = useState("");
  const [apiLinks, setApiLinks] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    GetApiLinks().then((res) => { if (res?.status === 200) setApiLinks(res.data); });
  }, []);

  const clearForm = () => { setRole(""); setDescription(""); setPermission([]); setPages([]); setRemark(""); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (permission.length === 0) {
      Swal.fire({ title: "No permissions", icon: "warning", text: "Please select at least one permission." });
      return;
    }
    setLoading(true);
    const cleanPerms = permission.map(({ method, path }) => ({ method, path }));
    const res = await StoreRole(role, description, cleanPerms, pages, remark);
    setLoading(false);
    if (res?.success) {
      clearForm();
      Swal.fire({ title: "Created!", icon: "success", text: `${role} has been created`, timer: 1500 })
        .then(() => { if (onCreated) onCreated(); });
    } else {
      Swal.fire({ title: "Error!", icon: "error", text: res?.data?.message || res?.message || "Create failed" });
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 800, pt: 1 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <FormControl fullWidth size="small">
            <InputLabel>Role name *</InputLabel>
            <OutlinedInput label="Role name *" value={role} onChange={(e) => setRole(e.target.value)} required />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={8}>
          <FormControl fullWidth size="small">
            <InputLabel>Description *</InputLabel>
            <OutlinedInput label="Description *" value={description} onChange={(e) => setDescription(e.target.value)} required />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth size="small" multiline maxRows={3} label="Remark" value={remark} onChange={(e) => setRemark(e.target.value)} />
        </Grid>

        <Grid item xs={12}>
          <Divider><Typography variant="caption" color="text.secondary">API Permissions</Typography></Divider>
        </Grid>
        <Grid item xs={12}>
          <PermissionEditor apiLinks={apiLinks} permission={permission} onChange={setPermission} />
        </Grid>

        <Grid item xs={12}>
          <Divider><Typography variant="caption" color="text.secondary">Page Access</Typography></Divider>
        </Grid>
        <Grid item xs={12}>
          <PagePermissionEditor pages={pages} onChange={setPages} />
        </Grid>

        <Grid item xs={12}>
          <Box display="flex" justifyContent="flex-end" gap={1}>
            <Button variant="outlined" color="secondary" onClick={clearForm} disabled={loading}>Clear</Button>
            <Button type="submit" variant="contained" color="secondary" disabled={loading}
              startIcon={loading && <CircularProgress size={16} />}>
              Create Role
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default NewRole;
